import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import { Link as RouterLink, useNavigate } from "react-router-dom";
// Sun, Moon icons and useTheme hook are temporarily unused — see dark-mode toggle TODO below.
// import { Sun, Moon, LogOut } from "lucide-react";
// import { useTheme } from "../context/ThemeContext";
import { LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { DRAWER_WIDTH } from "../constants/layout";

export function Header() {
  // TODO: Re-enable dark mode toggle once admin dark theme has been polished.
  // The toggle still works, but the dark palette is unfinished (contrast /
  // surface issues) and has been hidden from users to avoid a rough UX.
  // const { isDarkMode, toggleTheme } = useTheme();
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  // Navigate to /login BEFORE clearing auth state so ProtectedRoute does not
  // fire its redirect-with-preserved-location. That redirect is correct for
  // unauth users hitting a deep link, but wrong for explicit sign-out — the
  // user meant to end the session, not to be bounced back after re-login.
  async function handleSignOut() {
    navigate("/login", { replace: true });
    await signOut();
  }

  return (
    <AppBar
      position="fixed"
      sx={{
        width: `calc(100% - ${DRAWER_WIDTH}px)`,
        ml: `${DRAWER_WIDTH}px`,
      }}
    >
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }} noWrap>
          Flat Rock Events Admin
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {user && (
            <Link
              component={RouterLink}
              to={`/users/${user.uid}`}
              variant="body2"
              color="inherit"
              underline="hover"
              noWrap
              aria-label="View your profile"
            >
              {user.email}
            </Link>
          )}
          {/* Dark mode toggle — temporarily hidden, see TODO above.
          <IconButton color="inherit" onClick={toggleTheme} aria-label="Toggle dark mode">
            {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
          </IconButton>
          */}
          {user && (
            <IconButton color="inherit" onClick={handleSignOut} aria-label="Sign out">
              <LogOut size={20} />
            </IconButton>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
